import { render } from "./User_services.vue?vue&type=template&id=dd5c042c&scoped=true"
import script from "./User_services.vue?vue&type=script&lang=js"
export * from "./User_services.vue?vue&type=script&lang=js"

import "./User_services.vue?vue&type=style&index=0&id=dd5c042c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5c042c"]])

export default __exports__